import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// lazyload
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '',
  loading: '',
  attempt: 1
})


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.devtools = true;

import './utils/index'

// 创建事件总线
Vue.prototype.$EventBus = new Vue();

Vue.config.productionTip = false;

// 分享功能
import Share from 'vue-social-share'
Vue.use(Share)

// vue meta
import Meta from 'vue-meta';
Vue.use(Meta)


Vue.use(VueLazyload, {
  preLoad: 0.5,                //预加载图片的比例
  error: '',    //图片加载失败显示的图片
  loading: "./assets/imgs/home/bg_img.jpg",     //图片加载中显示的图片，防止白屏
  attempt: 5                    //一次加载几张
})
const vm = new Vue({
  router,
  data: {
    meta_title: "shanghaieye",
    meta_url: "1"
  },
  store,
  render: h => h(App)
}).$mount("#app");


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

